var map = {
	"./About-OOKI.svg": 1727,
	"./Add-OOKI.svg": 1728,
	"./Arrow-drop-down.svg": 1729,
	"./Arrow.svg": 1730,
	"./Blog.svg": 1731,
	"./Borrow.svg": 1732,
	"./Burger-menu.svg": 1733,
	"./DAO.svg": 1734,
	"./Dark.svg": 1735,
	"./Dashboard.svg": 1736,
	"./Down.svg": 1737,
	"./Drawer-close.svg": 1738,
	"./Drawer-open.svg": 1739,
	"./FAQ.svg": 1740,
	"./Facebook.svg": 1741,
	"./Favourite.svg": 1742,
	"./Filled.svg": 1743,
	"./Friends.svg": 1744,
	"./GreenFaceProfit.svg": 1745,
	"./HelpChat.svg": 1746,
	"./Hide.svg": 1747,
	"./History.svg": 1748,
	"./Inactive.svg": 1749,
	"./Instagram.svg": 1750,
	"./Learn.svg": 1751,
	"./Left.svg": 1752,
	"./Lend.svg": 1753,
	"./Light.svg": 1754,
	"./Link.svg": 1755,
	"./List.svg": 1756,
	"./Logo.svg": 1757,
	"./NFT.svg": 1758,
	"./Normal.svg": 1759,
	"./Opened.svg": 1760,
	"./Options.svg": 1761,
	"./Outline.svg": 1762,
	"./Pencil.svg": 1763,
	"./Photo.svg": 1764,
	"./Refresh.svg": 1765,
	"./Right.svg": 1766,
	"./Sandclock.svg": 1767,
	"./Select.svg": 1768,
	"./Selected.svg": 1769,
	"./Settings.svg": 1770,
	"./Share.svg": 1771,
	"./Shop.svg": 1772,
	"./Show.svg": 1773,
	"./Stake-OOKI.svg": 1774,
	"./Stake.svg": 1775,
	"./Stats.svg": 1776,
	"./Swap.svg": 1777,
	"./Time.svg": 1778,
	"./Trade.svg": 1779,
	"./Tutorial.svg": 1780,
	"./Up.svg": 1781,
	"./User.svg": 1782,
	"./Walkthrough.svg": 1783,
	"./Wallet.svg": 1784,
	"./Youtube.svg": 1785,
	"./announcement.svg": 1786,
	"./arbitrum-logo.svg": 1787,
	"./arrow-down.svg": 1788,
	"./arrow-right.svg": 1789,
	"./arrow-up.svg": 1790,
	"./binance-logo.svg": 1791,
	"./cOOKI.svg": 1792,
	"./caret-down.svg": 1793,
	"./caret-left.svg": 1794,
	"./caret-right.svg": 1795,
	"./chain-optimism.svg": 1796,
	"./check-circle.svg": 1797,
	"./close.svg": 1798,
	"./coinbase.svg": 1799,
	"./coincarp.svg": 1800,
	"./coingecko.svg": 1801,
	"./coinmarketcap.svg": 1802,
	"./coinpaprika.svg": 1803,
	"./copy.svg": 1804,
	"./cross.svg": 1805,
	"./crypto-com.svg": 1806,
	"./discord.svg": 1807,
	"./ethereum-logo.svg": 1808,
	"./filter.svg": 1809,
	"./gateio.svg": 1810,
	"./github.svg": 1811,
	"./ic_token_aave.svg": 1812,
	"./ic_token_auto.svg": 1813,
	"./ic_token_bnb.svg": 1814,
	"./ic_token_bpt.svg": 1815,
	"./ic_token_btc.svg": 1816,
	"./ic_token_busd.svg": 1817,
	"./ic_token_bzrx.svg": 1818,
	"./ic_token_bzrx_bnb.svg": 1819,
	"./ic_token_cake.svg": 1820,
	"./ic_token_chi.svg": 1821,
	"./ic_token_comp.svg": 1822,
	"./ic_token_crv.svg": 1823,
	"./ic_token_dai.svg": 1824,
	"./ic_token_doge.svg": 1825,
	"./ic_token_eth.svg": 1826,
	"./ic_token_iaave.svg": 1827,
	"./ic_token_iauto.svg": 1828,
	"./ic_token_ibnb.svg": 1829,
	"./ic_token_ibtc.svg": 1830,
	"./ic_token_ibusd.svg": 1831,
	"./ic_token_ibzrx.svg": 1832,
	"./ic_token_icake.svg": 1833,
	"./ic_token_idoge.svg": 1834,
	"./ic_token_ieth.svg": 1835,
	"./ic_token_ilink.svg": 1836,
	"./ic_token_imatic.svg": 1837,
	"./ic_token_ipolygon-matic.svg": 1838,
	"./ic_token_iusdt.svg": 1839,
	"./ic_token_knc.svg": 1840,
	"./ic_token_kncl.svg": 1841,
	"./ic_token_link.svg": 1842,
	"./ic_token_lrc.svg": 1843,
	"./ic_token_matic.svg": 1844,
	"./ic_token_mkr.svg": 1845,
	"./ic_token_ooki.svg": 1846,
	"./ic_token_quick.svg": 1847,
	"./ic_token_slp.svg": 1848,
	"./ic_token_susd.svg": 1849,
	"./ic_token_sushi.svg": 1850,
	"./ic_token_uni.svg": 1851,
	"./ic_token_usdc.svg": 1852,
	"./ic_token_usdt.svg": 1853,
	"./ic_token_vbzrx.svg": 1854,
	"./ic_token_wbtc.svg": 1855,
	"./ic_token_weth.svg": 1856,
	"./ic_token_yfi.svg": 1857,
	"./info.svg": 1858,
	"./kovan-logo.svg": 1859,
	"./kucoin.svg": 1860,
	"./lock.svg": 1861,
	"./medium.svg": 1862,
	"./menu-close.svg": 1863,
	"./menu-open.svg": 1864,
	"./mexcglobal.svg": 1865,
	"./ooki-black-white.svg": 1866,
	"./our-tokens.svg": 1867,
	"./polygon-logo.svg": 1868,
	"./save.svg": 1869,
	"./search.svg": 1870,
	"./sushiswap.svg": 1871,
	"./switch.svg": 1872,
	"./telegram.svg": 1873,
	"./token-ape.svg": 1874,
	"./token-bpt.svg": 1875,
	"./token-bzrx.svg": 1876,
	"./token-cooki.svg": 1877,
	"./token-crv.svg": 1878,
	"./token-frax.svg": 1879,
	"./token-ibzrx.svg": 1880,
	"./token-iooki.svg": 1881,
	"./token-mim.svg": 1882,
	"./token-ooki.svg": 1883,
	"./token-p125.svg": 1884,
	"./token-slp-ooki.svg": 1885,
	"./token-slp.svg": 1886,
	"./token-spell.svg": 1887,
	"./token-stmatic.svg": 1888,
	"./token-sushi.svg": 1889,
	"./token-vbzrx.svg": 1890,
	"./token-wsteth.svg": 1891,
	"./tools.svg": 1892,
	"./twitter.svg": 1893,
	"./uniswap.svg": 1894,
	"./wallet-balance.svg": 1895,
	"./wallet-connect.svg": 1896,
	"./wazirx.svg": 1897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1726;